import { Link } from "react-router-dom";
import AnimeCard from "@/components/base/AnimeCard";
import { animeList } from "@/mocks/anime";

export default function FeaturedAnime() {
  const featured = [...animeList].sort((a, b) => b.popularity - a.popularity).slice(0, 6);
  return (
    <section>
      <div className="flex items-end justify-between mb-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading font-bold text-foreground-950 text-lg md:text-xl">
            <i className="ri-fire-line text-primary-500" />
            动漫作品热门推荐
          </h2>
          <p className="mt-1 text-xs md:text-sm text-foreground-600">按热度精选，每一部都值得加入追番列表</p>
        </div>
        <Link to="/anime" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer whitespace-nowrap">
          全部作品 <i className="ri-arrow-right-s-line align-middle" />
        </Link>
      </div>
      <div data-product-shop className="grid grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
        {featured.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}